import {confettiBelowModal} from '../../../lib/confetti'

const REWARD_CONFIRMATION_EVENT = 'profile.promotion-status.notification'

export default (Bus) => {
  confettiBelowModal(Bus, REWARD_CONFIRMATION_EVENT)
}

